const animation = require("./CoinJump.json");

module.exports = {
    loop: true,
    autoplay: false,
    prerender: true,
    renderer: "svg",
    animationData: animation,
    rendererSettings: {
        preserveAspectRatio: 'xMidyMid'
    },
}